(function (exports, global) {
    global["true"] = exports;
    angular.module("app").filter("errorNames", function () {
        return function (error) {
            var text;
            if (_.isUndefined(error)) return text;
            switch (error) {
                case "ccNumber":
                    text = "is not valid";
                    break;
                case "ccNumberType":
                    text = "is not valid";
                    break;
                case "ccExpMonth":
                    text = "is not valid";
                    break;
                case "ccExpYear":
                    text = "is not valid";
                    break;
                case "ccCvc":
                    text = "is not valid";
                    break;
                case "required":
                    text = "is required";
                    break;
                case "isInPast":
                    text = "Pickup time is in the past";
                    break;
                default:
                    text = "has errors";
            }
            return text;
        };
    });
})({}, function () {
    return this;
}());
//# sourceMappingURL=errorsFIlter.js.map